import React from "react";

function Banner({ title, subtitle }) {
  return (
    <div
      className="text-white text-center d-flex align-items-center"
      style={{
        minHeight: "60vh",
        background:
          "linear-gradient(rgba(0,0,0,.6), rgba(0,0,0,.6)), url('https://images.unsplash.com/photo-1500530855697-b586d89ba3ee') center/cover",
      }}
    >
      <div className="container">
        <h1 className="display-5 fw-bold">{title}</h1>
        <p className="lead mt-3">{subtitle}</p>
      </div>
    </div>
  );
}

export default Banner;
